var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-admin-block"},[_c('b-container',[_c('h3',[_vm._v("О нас")]),_c('hr'),_c('page-editor',{attrs:{"alias":'about'}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }